import { resourceType } from 'constants/loading';
import { findResource } from 'loading/finders';

import { canProxy } from 'user/selectors';
import { getActiveUserId } from 'current/selectors';
import { getAllFields, getFieldsForOperations } from 'fields/selectors';
import { isAppMode } from 'settings/selectors';
import { areFieldsForOperationLoaded } from 'operations/selectors';

import { fetchAllOwnedFields, fetchAllSharedFields, fetchFieldsByOperations } from 'fields/loaders';
import { parseAllFields } from 'fields/homesteadParser';
import { processAllFields, processFields } from 'fields/processors';
import { parseFields } from './parsers';
import { treatErrorAs } from 'api/errors';
import { errorLevel } from 'constants/errors';

export const findAllFields = ({ dispatch, getState, forceReload=false, forceWait=false, onError }) => {
  return Promise.resolve()
  .then( () => {
    const state = getState();
    const userId = getActiveUserId(state);
    let fetchFields;
    // if app mode, the user will not be proxying, so they can always request anything accessible to them
    if (isAppMode(state)) {
      fetchFields = fetchAllSharedFields;
    } else {
      fetchFields = canProxy(state) ? fetchAllOwnedFields : fetchAllSharedFields;
    }
    const resourceSpec = {
      type: resourceType.FIELDS,
      selector: () => getAllFields(getState()),
      fetcher: () => fetchFields({ userId }),
      processor: ( raw ) => processAllFields({ dispatch, getState, fields: parseAllFields( raw ) })
    };

    return findResource({ dispatch, getState, forceReload, forceWait, onError, ...resourceSpec });
  });
};

export const findFieldsByOperations = async ({ dispatch, getState, operationsIds }) => {
  const operationsFieldsNotLoaded = operationsIds.filter((uuid) => areFieldsForOperationLoaded(getState(), uuid));
  
  const resourceSpec = {
    type: resourceType.FIELDS,
    selector: () => getFieldsForOperations(getState(), operationsIds),
    fetcher: () => fetchFieldsByOperations(operationsIds),
    processor: (raw) => processFields({ dispatch, fields: parseFields(raw), operationsIds }),
    forceWait: true,
    forceReload: operationsFieldsNotLoaded.length,
    onError: treatErrorAs({ severity: errorLevel.BLOCK })
  };

  return findResource({ dispatch, getState, ...resourceSpec });
};
